import { formReducer, modelReducer } from 'react-redux-form'
import { combineReducers } from 'redux'

const initialSurveyCreationModel = {
  name: '',
  description: '',
  buttonText: '',
  ccResponsesTo: ''
}
const initialSurveyTextQuestionModel = {
  title: '',
  description: '',
  multiLine: false,
  responseRequired: false,
  orderBy: null
}
const initialSurveyFileQuestionModel = {
  title: '',
  description: '',
  responseRequired: false,
  orderBy: null
}
const initialSurveyMultiChoiceQuestionModel = {
  title: '',
  description: '',
  responseRequired: false,
  options: [],
  noSelectionText: '',
  orderBy: null
}
const initialSurveyMultiChoiceOccupationModel = {
  title: '',
  description: '',
  responseRequired: false,
  minJobZone: null,
  maxJobZone: null,
  primaryInterest: null,
  cluster: null,
  orderBy: null
}
const initialSurveyMultiChoiceInstructionalProgramModel = {
  title: '',
  description: '',
  responseRequired: false
}
const initialSurveyMultiChoiceEducationalInstitutionModel = {
  title: '',
  description: '',
  responseRequired: false
}
const initialSurveyMultiChoiceClusterModel = {
  title: '',
  description: '',
  responseRequired: false
}
const initialSurveyRatingQuestionModel = {
  title: '',
  description: '',
  responseRequired: false,
  orderBy: null
}

export default combineReducers({
  createSurveyForm: modelReducer(
    'survey.surveyForms.createSurveyForm',
    initialSurveyCreationModel
  ),
  surveyTextQuestionForm: modelReducer(
    'survey.surveyForms.surveyTextQuestionForm',
    initialSurveyTextQuestionModel
  ),
  surveyRatingQuestionForm: modelReducer(
    'survey.surveyForms.surveyRatingQuestionForm',
    initialSurveyRatingQuestionModel
  ),
  surveyMultiChoiceQuestionForm: modelReducer(
    'survey.surveyForms.surveyMultiChoiceQuestionForm',
    initialSurveyMultiChoiceQuestionModel
  ),
  surveyMultiChoiceOccupationForm: modelReducer(
    'survey.surveyForms.surveyMultiChoiceOccupationForm',
    initialSurveyMultiChoiceOccupationModel
  ),
  surveyMultiChoiceInstructionalProgramForm: modelReducer(
    'survey.surveyForms.surveyMultiChoiceInstructionalProgramForm',
    initialSurveyMultiChoiceInstructionalProgramModel
  ),
  surveyMultiChoiceEducationalInstitutionForm: modelReducer(
    'survey.surveyForms.surveyMultiChoiceEducationalInstitutionForm',
    initialSurveyMultiChoiceEducationalInstitutionModel
  ),
  surveyFileQuestionForm: modelReducer(
    'survey.surveyForms.surveyFileQuestionForm',
    initialSurveyFileQuestionModel
  ),
  surveyMultiChoiceClusterForm: modelReducer(
    'survey.surveyForms.surveyMultiChoiceClusterForm',
    initialSurveyMultiChoiceClusterModel
  ),
  forms: formReducer('survey.surveyForms', {
    createSurveyForm: initialSurveyCreationModel,
    surveyTextQuestionForm: initialSurveyTextQuestionModel,
    surveyRatingQuestionForm: initialSurveyRatingQuestionModel,
    surveyMultiChoiceQuestionForm: initialSurveyMultiChoiceQuestionModel,
    surveyMultiChoiceOccupationForm: initialSurveyMultiChoiceOccupationModel,
    surveyMultiChoiceInstructionalProgramForm: initialSurveyMultiChoiceInstructionalProgramModel,
    surveyMultiChoiceEducationalInstitutionForm: initialSurveyMultiChoiceEducationalInstitutionModel,
    surveyFileQuestionForm: initialSurveyFileQuestionModel,
    surveyMultiChoiceClusterForm: initialSurveyMultiChoiceClusterModel
  })
})
